const fromTimeSlotsQueryToTimeSlots = (data) => {
  if (!data) {
    return null;
  }
  return data.map(({ from, until }) => ({ from: new Date(from), until: new Date(until) }));
};
export {
  fromTimeSlotsQueryToTimeSlots
};
//# sourceMappingURL=fromTimeSlotsQueryToTimeSlots.js.map
